import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Accent, SectionHeading } from './SectionHeading';
import { afterItems, beforeItems } from '../../data/content';
export function BeforeAfterSection() {
  return <section aria-labelledby="compare-heading" className="bg-brand-oatmeal px-5 py-16 lg:px-8 lg:py-24" data-id="element-56" data-mp="1xotspxz95xp4">
      <div className="mx-auto max-w-5xl" data-id="element-57" data-mp="22nohdgjwigh5">
        <SectionHeading id="compare-heading" title={<>
              Imagine Preparing Your Next PMU Class <Accent data-id="element-59" data-mp="1sr1z8ziym3it">Differently…</Accent>
            </>} data-id="element-58" data-mp="22qsrsvnym8g9" />

        <div className="mt-12 grid gap-5 md:grid-cols-2" data-id="element-60" data-mp="1ezdl6qp5h4z7">
          <div className="rounded-[20px] bg-brand-ivory/70 p-7 sm:p-9" data-id="element-61" data-mp="1f0yg4hfdmpxl">
            <h3 className="font-body text-[12px] font-bold uppercase tracking-[0.16em] text-brand-charcoal/55" data-id="element-62" data-mp="1jzjkmt1nvvru">
              Before PMU Instructor Ready™
            </h3>
            <ul className="mt-6 space-y-3.5" role="list" data-id="element-63" data-mp="1a011getkse0u">
              {beforeItems.map(item => <li key={item} className="flex items-start gap-3 text-[15px] leading-snug text-brand-charcoal/60" data-id="element-64" data-mp="277goepd4ocb5">
                  <XIcon className="mt-0.5 h-4 w-4 flex-none text-[#B5655E]" strokeWidth={2.25} aria-hidden="true" data-id="element-65" data-mp="229f1tughtuux" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="rounded-[20px] border-2 border-brand-cta/40 bg-white p-7 shadow-[0_30px_60px_-40px_rgba(30,82,54,0.55)] sm:p-9" data-id="element-66" data-mp="2c7uw26athk8n">
            <h3 className="font-body text-[12px] font-bold uppercase tracking-[0.16em] text-brand-cta" data-id="element-67" data-mp="1of4hrqffyov7">
              With PMU Instructor Ready™
            </h3>
            <ul className="mt-6 space-y-3.5" role="list" data-id="element-68" data-mp="1xac8v8dsff3b">
              {afterItems.map(item => <li key={item} className="flex items-start gap-3 text-[15px] font-medium leading-snug text-brand-charcoal" data-id="element-69" data-mp="1si0wv75rw2ue">
                  <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-brand-cta" strokeWidth={2.5} aria-hidden="true" data-id="element-70" data-mp="14rexs5dqxswj" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mx-auto mt-12 max-w-2xl text-center font-display text-[1.6rem] font-bold leading-snug text-brand-charcoal sm:text-[1.9rem]" data-id="element-71" data-mp="34vhj3lm8p3tt">
          Less preparation work. <Accent data-id="element-72" data-mp="39mzi444pcuc5">More focus on your students.</Accent>
        </p>
      </div>
    </section>;
}